import styled from 'styled-components';

const Link = styled.button`
  text-decoration: none;
  background: transparent;
  color: #204ff6;
  transition: color 0.5s;
  margin-top: 15px;
  border: none;
  margin-top: 80px;
  outline-style: none;

  &:hover {
    color: #456eff;
    cursor: pointer;
  }
`;

export { Link };
